import React from 'react';
import type { PassportEncounter } from '../../services/api/passport';
import { encounterCard } from './sourceCards';
import { formatEncounterDate } from './passportCopy';
import CollectorCard from './CollectorCard';

type Props = {
  encounters: PassportEncounter[];
  onOpen?: (publicId: string, subjectType: string) => void;
};
/** Encounter evidence stays separate from base ownership and published editions. */
export const PassportDiscoveriesRail: React.FC<Props> = ({ encounters, onOpen }) => {
  const recent = encounters.slice(0, 12);
  if (!recent.length) return null;
  return (
    <section className="mb-10" aria-labelledby="passport-discoveries-heading">
      <h2 id="passport-discoveries-heading" className="text-lg font-semibold text-white">
        Latest discoveries
      </h2>
      <p className="mt-1 text-sm text-zinc-500">Recent encounters and their recorded evidence.</p>
      <div className="collector-shelf">
        {recent.map((encounter) => {
          const card = encounterCard(encounter);
          return (
            <CollectorCard
              key={encounter.public_id}
              card={card}
              href={`/passport/encounters/${encodeURIComponent(encounter.public_id)}`}
              openLabel="View encounter"
              onOpen={() => onOpen?.(encounter.public_id, encounter.subject_type)}
              fullRecordExtension={
                <>
                  <p className="text-xs text-zinc-400">
                    {encounter.status} · {formatEncounterDate(encounter.occurred_at)}
                  </p>
                </>
              }
            />
          );
        })}
      </div>
    </section>
  );
};
export default PassportDiscoveriesRail;
